import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { skeletonBusyProps, skeletonRoundedSx } from './skeletonCommon'

interface Props {
  readonly testId?: string
}

export function SurveyEntrySkeleton({ testId = 'instrument-info-loading' }: Readonly<Props>) {
  return (
    <Box
      data-testid={testId}
      {...skeletonBusyProps}
      aria-label="Loading survey details"
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
    >
      <Skeleton variant="rounded" width={120} height={28} sx={{ borderRadius: '8px' }} />
      <Skeleton variant="rounded" width="85%" height={32} sx={skeletonRoundedSx} />
      <Skeleton variant="rounded" width="100%" height={20} sx={{ borderRadius: '6px' }} />
      <Skeleton variant="rounded" width="100%" height={20} sx={{ borderRadius: '6px' }} />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 1 }}>
        <Skeleton variant="rounded" height={72} sx={skeletonRoundedSx} />
        <Skeleton variant="rounded" height={72} sx={skeletonRoundedSx} />
      </Box>
      <Skeleton variant="rounded" width="100%" height={44} sx={{ ...skeletonRoundedSx, mt: 2 }} />
    </Box>
  )
}
